const loaderClass = 'loader-container';
const loaderHTML = `<div class="${loaderClass}-icon spinner spinner--small"></div>`;

module.exports = {
  /**
   * @param  {Node} element - Elements parent to be replaced with the loader
   */
  replaceWithLoader: (element) => {
    // eslint-disable-next-line no-param-reassign
    element.innerHTML = loaderHTML;
  },
  /**
   * @param  {Node} element - Element where loader is added
   */
  addLoader: (element) => {
    element.classList.add(loaderClass);
    element.insertAdjacentHTML('afterbegin', loaderHTML);
  },
  /**
   * @param  {Node} element - Element where loader is to be removed
   */
  removeLoader: (element) => {
    const loader = element.querySelector(`.${loaderClass}-icon`);
    loader.remove();
    element.classList.remove(loaderClass);
  },
};
